<template>
    <div class="upcoming-events">
        <div class = "upcoming-events-content-container">
            <content-header class="upcoming-events-content-header" 
            text="Ближайшие события"
            @svgClick="changeCalendarStatus()"
            :svgData="svgData"/>
            <div v-if="this.showCalendar">
                <div class="upcoming-events-calendar-card">
                    <upcoming-events-calendar-card/>
                </div>
            </div>
        </div>
        <div class="upcoming-events-slider">
            <upcoming-events-slider/>
        </div>
    </div>
</template>
<script>

import ContentHeader from '@/components/content/ContentHeader.vue'
import UpcomingEventsSlider from '@/components/upcomingEvents/UpcomingEventsSlider.vue';
import UpcomingEventsCalendarCard from '@/components/calendarCard/UpcomingEventsCalendarCard.vue';
import { useEventsStore } from '@/store/events'

export default{
    name: 'HomeUpcomingEvents',
    components: {
        ContentHeader,
        UpcomingEventsSlider,
        UpcomingEventsCalendarCard
    },
    data() {
        return {
            showCalendar: false,
            svgData: {
                class: "upcoming-events-svg",
                width: "31",
                height: "32",
                viewBox: "0 0 31 32",
                pathArr: [{
                    d: "M6.73913 0C6.00204 0 5.3913 0.604167 5.3913 1.33333V2.66667H1.34783C0.995075 2.66667 0.637059 2.79427 0.384341 3.04688C0.128991 3.29688 0 3.65104 0 4V30.6667C0 31.0156 0.128991 31.3698 0.384341 31.6224C0.637059 31.8724 0.995075 32 1.34783 32H29.6522C30.0049 32 30.3629 31.8724 30.6183 31.6224C30.871 31.3698 31 31.0156 31 30.6667V4C31 3.65104 30.871 3.29688 30.6183 3.04688C30.3629 2.79427 30.0049 2.66667 29.6522 2.66667H25.6087V1.33333C25.6087 0.604167 24.998 0 24.2609 0H22.913C22.176 0 21.5652 0.604167 21.5652 1.33333V2.66667H9.43478V1.33333C9.43478 0.604167 8.82405 0 8.08696 0H6.73913ZM6.73913 1.33333H8.08696V5.33333H6.73913V1.33333ZM22.913 1.33333H24.2609V5.33333H22.913V1.33333ZM1.34783 4H5.3913V5.33333C5.3913 6.0625 6.00204 6.66667 6.73913 6.66667H8.08696C8.82405 6.66667 9.43478 6.0625 9.43478 5.33333V4H21.5652V5.33333C21.5652 6.0625 22.176 6.66667 22.913 6.66667H24.2609C24.998 6.66667 25.6087 6.0625 25.6087 5.33333V4H29.6522V8.66667H1.34783V4ZM1.34783 10H29.6522V30.6667H1.34783V10ZM5.3913 12.6667V28H25.6087V12.6667H5.3913ZM6.73913 14H10.1087V17.3333H6.73913V14ZM11.4565 14H14.8261V17.3333H11.4565V14ZM16.1739 14H19.5435V17.3333H16.1739V14ZM20.8913 14H24.2609V17.3333H20.8913V14ZM6.73913 18.6667H10.1087V22H6.73913V18.6667ZM11.4565 18.6667H14.8261V22H11.4565V18.6667ZM16.1739 18.6667H19.5435V22H16.1739V18.6667ZM20.8913 18.6667H24.2609V22H20.8913V18.6667ZM6.73913 23.3333H10.1087V26.6667H6.73913V23.3333ZM11.4565 23.3333H14.8261V26.6667H11.4565V23.3333ZM16.1739 23.3333H19.5435V26.6667H16.1739V23.3333ZM20.8913 23.3333H24.2609V26.6667H20.8913V23.3333Z",
                    fill: "#001FA3"
                }]
            }
        }
    },
    methods: {
        changeCalendarStatus() {
            this.showCalendar = !this.showCalendar
        }
    },
    async mounted(){
        const eventsStore = useEventsStore()
        await eventsStore.getAllEvents()
        // if (!eventsStore.dateIsSelected)
        eventsStore.setDateToThisMonth()
    }
}
</script>